import solver from 'solver-utilities';

window.onload = async function () {
  document.body.classList.add('page--loaded');
  console.info('Custom Scripts Ready');
};
